import React, { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import "react-toastify/dist/ReactToastify.css";
import TableComponent from "../../../../../components/tableComponent/TableComponent";
import axiosMain from "../../../../../http/axios/axios_main";
import MenualForm from "./MenualForm";
import CustomToast from "../../../../../components/Toast";
import { useAuctionDetail } from "../../../../../components/common/AunctioneerDeteailProvider";
import Modals from "../../../../../components/common/Modal";
import { Button } from "react-bootstrap";
import { useLoader } from "../../../../../components/common/Loder/Loder";
import { checkAllcoulm } from "../../../../../components/common/uploadFile/utils";
import { fetchSaleNumbersRequest } from "../../../../../store/actions";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import { FormControl, InputGroup } from "react-bootstrap";

const currentYear = new Date().getFullYear();
const initialValues = {
  season: "",
  saleNo: "0",
};
const validationSchema = Yup.object().shape({
  saleNo: Yup.number()
    .min(1, "Please select Sale No")
    .required("Sale No is required"),
  season: Yup.string().required("Please select Season"),
});
function ExcelUploadComponent({
  isDisable,
  isEdit,
  seasonpass,
  saleNopass,
  setExpandedTab,
  getSampledata, expandedTab, dataRow
}) {
  const {
    auctionDetailId,
    auctionCenterUserId,
    roleCode,
    auctionCenterId,
    userId,
    auction,
    auctionTypeMasterCode,
  } = useAuctionDetail();
  const dispatch = useDispatch();
  const { isLoading, openLoader, closeLoader, toggleLoader } = useLoader();

  const [auctionTypeCode, setAuctionTypeCode] = useState(auctionTypeMasterCode);
  const baseUrlEng =
    auction === "ENGLISH" ? "EnglishAuctionSampleShortage" : "SampleShortage";
  const [files, setFiles] = useState([]);
  const [rows, setRows] = useState([]);
  const [viewData, setViewData] = useState([]);
  const [openConformaionModal, setOpenConformaionModal] = useState(false);
  const [
    openModalConformationInvalidData,
    setOpenModalConformationInvalidData,
  ] = useState(false);
  const [
    openModalConformationInvalidDataTitle,
    setOpenModalConformationInvalidDataTitle,
  ] = useState({});
  const fileInputRef = useRef(null);
  const [saleNumber, setsaleNumber] = useState([]);

  // const saleNumber = useSelector(
  //   (state) => state?.CreatedSaleNo?.saleNumbers?.responseData
  // );
  console.log(dataRow, "roww")
  function generateYearOptions() {
    const currentYear = new Date().getFullYear();
    const options = [];

    for (let i = currentYear; i > currentYear - 7; i--) {
      options.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }

    return options;
  }
  const formik = useFormik({
    initialValues: initialValues,

    validationSchema,
    onSubmit: (values) => {
      fileInputRef.current.click();
    },
  });

  useEffect(() => {
    formik.setFieldValue("season", "");
    formik.setFieldValue("saleNo", "0");
  }, [expandedTab]);
  useEffect(() => {
    const season = formik.values.season?.toString();
    if ((season !== "") & (season !== undefined)) {
      debugger;
      const seasondata = {
        season: formik.values.season.toString(),
        auctionCenterId: auctionCenterId,
      };
      axiosMain
        .post(`/preauction/Common/BindSaleNoBySeason`, seasondata)
        .then((res) => {
          setsaleNumber(res.data.responseData);
          // formik.setFieldValue("saleNo", res.data.responseData?.at(0).saleNo);
        })
        .catch((err) => console.log(err));
      // dispatch(fetchSaleNumbersRequest(formik.values.season));
    }
  }, [formik.values.season]);
  // useEffect(() => {
  //   const season = formik.values.season?.toString();
  //   if ((season !== "") & (season !== undefined)) {
  //     dispatch(fetchSaleNumbersRequest(formik.values.season));
  //   }
  // }, [formik.values.season]);
  const { handleChange, handleBlur, values, touched, errors } = formik;
  // useEffect(() => {
  //   if (saleNumber?.length > 0) {
  //     formik.setFieldValue("saleNo", saleNumber?.at(0)?.saleNo);
  //   }
  //   else {
  //     formik.setFieldValue("saleNo", "");
  //   }

  // }, [saleNumber]);

  const isValid = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the first sheet in the Excel file contains data
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet data into a JSON object
      let jsonData = XLSX.utils.sheet_to_json(worksheet);
      console.log(jsonData, "jsonDatajsonData");
      //jsonData = jsonData.filter((ele) => ele.hasOwnProperty("LOTNO"));
      const hasLOTNO = jsonData.find((ele) => !ele.hasOwnProperty("LOTNO"));

      // if (hasLOTNO?.length > 0) {
      //   const rowno = jsonData.findIndex(
      //     (ele, index) => !ele.hasOwnProperty("LOTNO") && index + 1
      //   );
      //   console.log(
      //     "The Lot No is Mandatory Field , lotno rows " +
      //       rowno.join(",") +
      //       "goes Blank"
      //   );
      //   return false;
      // }
      if (
        jsonData
          .map((ele, index) => !ele.hasOwnProperty("LOTNO"))
          .includes(true)
      ) {
        const inrowno = jsonData
          .map((ele, index) => !ele.hasOwnProperty("LOTNO"))
          .map((ele, index) => ele === true && index + 1)
          .filter((ele) => ele != false);
        CustomToast.error(
          "The Lot No is Mandatory Field , lotno rows " +
          inrowno.join(",") +
          " goes Blank"
        );
        return false;
      }
      // Check for mandatory columns and blank cells
      const mandatoryColumns = [
        "InspectionChgs",
        "LOTNO",
        "PACKAGENO",
        "ReInspectionChgs",
        "SAMPLEWT",
        "SHORTWT",
      ];
      let isValidData = true;

      jsonData.forEach((row, rowIndex) => {
        for (const column of mandatoryColumns) {
          if (!row[column] === "") {
            CustomToast.error(`Row ${rowIndex + 2}: ${column} is missing data`);
            isValidData = false;
            fileInputRef.current.value = "";
            return false;
          }
        }
      });
      debugger;
      let fileData = jsonData.map((ele) => {
        let data = {
          LotNo: ele.LOTNO?.toString(),
          packageNo: ele.PACKAGENO?.toString(),
          createdBy: userId, //auctioner
          // season: ele.season?.toString(),
          // saleNo: parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
          auctionCenterId: auctionCenterId,
        };
        return data;
      });

      return isValidData;
    };

    return reader.readAsArrayBuffer(file);
  };

  const handleSubmit = () => {
    if (
      fileInputRef.current.value === "" ||
      fileInputRef.current.value === undefined ||
      fileInputRef.current.value === null
    ) {
      CustomToast.error("Please Select Excel file");
      return false;
    }
    // if (files.length === 0) {
    //   CustomToast.error("Please select excel file");
    //   return;
    // }

    let dataList = rows.filter(
      (ele) =>
        ele.InspectionChgs === undefined ||
        ele.InspectionChgs === "" ||
        ele.ReInspectionChgs === undefined ||
        ele.ReInspectionChgs === ""
    );
    if (
      rows.filter(
        (ele) =>
          ele?.LOTNO !== undefined ||
          ele?.PACKAGENO !== undefined ||
          ele?.ReInspectionChgs !== undefined ||
          ele?.SAMPLEWT !== undefined ||
          ele?.SHORTWT !== undefined
      )?.length > 0
    ) {
      // If validation fails, display the error message
      // files?.map((selectedFile) => {
      //   if (!isValid(selectedFile)) {
      //     CustomToast.error(
      //       `Validation is unsuccessful for ${selectedFile.name}`
      //     );
      //     return false;
      //   }
      // });

      if (
        rows.map((ele, index) => !ele.hasOwnProperty("LOTNO")).includes(true)
      ) {
        const inrowno = rows
          .map((ele, index) => !ele.hasOwnProperty("LOTNO"))
          .map((ele, index) => ele === true && index + 1)
          .filter((ele) => ele != false);
        CustomToast.error(
          "Please enter lot no in row no. " + inrowno.join(",")
        );
        return false;
      }
      // if (
      //   rows
      //     .map((ele, index) => !ele.hasOwnProperty("PACKAGENO"))
      //     .includes(true)
      // ) {
      //   const inrowno = rows
      //     .map((ele, index) => !ele.hasOwnProperty("PACKAGENO"))
      //     .map((ele, index) => ele === true && index + 1)
      //     .filter((ele) => ele != false);
      //   CustomToast.error(
      //     "The Package No is Mandatory Field , Package No rows " +
      //       inrowno.join(",") +
      //       " goes Blank"
      //   );
      //   return false;
      // }
      debugger;
      if (
        rows.filter(
          (ele) => (ele.PACKAGENO || /^[0-9]+$/.test(ele.PACKAGENO)) === false
        ).length > 0
        // rows.filter((ele) => ele.PACKAGENO?.toString()?.includes("."))?.length >
        //   0 ||
        // rows.filter((ele) => ele.PACKAGENO && /^[A-Za-z]+$/.test(ele.PACKAGENO))
        //   ?.length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate value of Package No in lot no. " +
          rows
            .map((ele) =>
              (ele.PACKAGENO || /^[0-9]+$/.test(ele.PACKAGENO)) === false
                ? ele.LOTNO
                : ""
            )
            ?.filter((ele) => ele !== "")
            .join(",")
        );

        return false;
      }

      const mandatoryColumns = [
        "InspectionChgs",
        "LOTNO",
        "PACKAGENO",
        "ReInspectionChgs",
        "SAMPLEWT",
        "SHORTWT",
      ];

      // if (
      //   rows.map((ele, index) => !ele.hasOwnProperty("SAMPLEWT")).includes(true)
      // ) {
      //   const inrowno = rows
      //     .map((ele, index) => !ele.hasOwnProperty("SAMPLEWT"))
      //     .map((ele, index) => ele === true && index + 1)
      //     .filter((ele) => ele != false);
      //   CustomToast.error(
      //     "The Sample Weight is Mandatory Field , Sample Weight  rows " +
      //       inrowno.join(",") +
      //       " goes Blank"
      //   );
      //   return false;
      // }
      if (
        rows.filter(
          (ele) =>
            isNaN(parseFloat(ele.SAMPLEWT)) ||
            ele.SAMPLEWT?.toString().includes("-") ||
            /^[0-9]+(\.[0-9]+)?$/.test(ele.SAMPLEWT) === false
        ).length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Sample Weight in lot no. " +
          rows
            .map((ele) =>
              isNaN(parseFloat(ele.SAMPLEWT)) ||
                ele.SAMPLEWT?.toString().includes("-") ||
                /^[0-9]+(\.[0-9]+)?$/.test(ele.SAMPLEWT) === false
                ? ele.LOTNO
                : ""
            )
            ?.filter((ele) => ele !== "")
            .join(",")
        );

        return false;
      }
      if (
        rows.filter(
          (ele) =>
            isNaN(parseFloat(ele.SHORTWT)) ||
            ele.SHORTWT?.toString().includes("-") ||
            /^[0-9]+(\.[0-9]+)?$/.test(ele.SHORTWT) === false
        ).length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Short Weight in lot no. " +
          rows
            .map((ele) =>
              isNaN(parseFloat(ele.SHORTWT)) ||
                ele.SHORTWT?.toString().includes("-") ||
                /^[0-9]+(\.[0-9]+)?$/.test(ele.SHORTWT) === false
                ? ele.LOTNO
                : ""
            )
            ?.filter((ele) => ele !== "")
            .join(",")
        );

        return false;
      }

      // if (
      //   rows
      //     .map((ele, index) => !ele.hasOwnProperty("InspectionChgs"))
      //     .includes(true)
      // ) {
      //   const inrowno = rows
      //     .map((ele, index) => !ele.hasOwnProperty("InspectionChgs"))
      //     .map((ele, index) => ele === true && index + 1)
      //     .filter((ele) => ele != false);
      //   CustomToast.error(
      //     "The Inspection Charges is Mandatory Field , Inspection Charges rows " +
      //       inrowno.join(",") +
      //       " goes Blank"
      //   );
      //   return false;
      // }
      if (
        rows.filter(
          (ele) =>
            isNaN(parseFloat(ele.InspectionChgs)) ||
            ele.InspectionChgs?.toString().includes("-") ||
            /^[0-9]+(\.[0-9]+)?$/.test(ele.InspectionChgs) === false
        ).length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Inspection Charges in lot no. " +
          rows
            .map((ele) =>
              isNaN(parseFloat(ele.InspectionChgs)) ||
                ele.InspectionChgs?.toString().includes("-") ||
                /^[0-9]+(\.[0-9]+)?$/.test(ele.InspectionChgs) === false
                ? ele.LOTNO
                : ""
            )
            ?.filter((ele) => ele !== "")
            .join(",")
        );

        return false;
      }

      // if (
      //   rows
      //     .map((ele, index) => !ele.hasOwnProperty("ReInspectionChgs"))
      //     .includes(true)
      // ) {
      //   const inrowno = rows
      //     .map((ele, index) => !ele.hasOwnProperty("ReInspectionChgs"))
      //     .map((ele, index) => ele === true && index + 1)
      //     .filter((ele) => ele != false);
      //   CustomToast.error(
      //     "The Re-Inspection Charges is Mandatory Field , Re-Inspection Charges rows " +
      //       inrowno.join(",") +
      //       " goes Blank"
      //   );
      //   return false;
      // }
      if (
        rows.filter(
          (ele) =>
            isNaN(parseFloat(ele.ReInspectionChgs)) ||
            ele.ReInspectionChgs?.toString().includes("-") ||
            /^[0-9]+(\.[0-9]+)?$/.test(ele.ReInspectionChgs) === false
        ).length > 0
      ) {
        CustomToast.error(
          "Please enter appropriate Re-inspection Charges in lot no. " +
          rows
            .map((ele) =>
              isNaN(parseFloat(ele.ReInspectionChgs)) ||
                ele.ReInspectionChgs?.toString().includes("-") ||
                /^[0-9]+(\.[0-9]+)?$/.test(ele.ReInspectionChgs) === false
                ? ele.LOTNO
                : ""
            )
            ?.filter((ele) => ele !== "")
            .join(",")
        );

        return false;
      }

      if (
        rows.map((ele, index) => !ele.hasOwnProperty("SHORTWT")).includes(true)
      ) {
        const inrowno = rows
          .map((ele, index) => !ele.hasOwnProperty("SHORTWT"))
          .map((ele, index) => ele === true && index + 1)
          .filter((ele) => ele != false);
        CustomToast.error(
          "The Sample Weight is Mandatory Field , Sample Weight rows " +
          inrowno.join(",") +
          " goes Blank"
        );
        return false;
      }

      if (dataList.length > 0) {
        CustomToast.error(
          "Inspection Charges and Re-Inspection Charges can not be blank"
        );
      } else if (rows.length === 0) {
        CustomToast.error("Validation is unsuccessful.");
      } else {
        openLoader();
        let fileData = rows.map((ele) => {
          let data = {
            LotNo: ele.LOTNO?.toString(),
            packageNo: ele.PACKAGENO?.toString(),
            createdBy: userId, //auctioner
            // season: ele.season?.toString(),
            // saleNo: parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
            auctionCenterId: auctionCenterId,
          };
          return data;
        });
        axiosMain
          .post(`/preauction/${baseUrlEng}/CheckPackageNoByLotNo?season=` + formik.values.season + "&saleNo=" + formik.values.saleNo, fileData)
          .then((res) => {
            if (res.data.statusCode === 200) {
              // openLoader();
              // console.log(rows, "rowrowrow");
              let data = rows.map((ele) => {
                let results = {
                  LotNo: ele.LOTNO?.toString(),
                  packageNo: ele.PACKAGENO?.toString(),
                  sampleWeight: parseFloat(ele.SAMPLEWT),
                  shortWeight: parseFloat(ele.SHORTWT),
                  inspectionCharges: parseFloat(ele.InspectionChgs),
                  reInspectionCharges: parseFloat(ele.ReInspectionChgs),
                  isActive: true,
                  createdBy: userId, //auctioner
                  updatedBy: userId, //auctioner
                  // season: ele.season?.toString(),
                  // saleNo: parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
                  auctionCenterId: auctionCenterId,
                };

                return results;
              });

              axiosMain
                .post(
                  `/preauction/${baseUrlEng}/UploadSampleShortage?role=` +
                  roleCode +
                  "&validateAction=validate&dataFlag=Excel&season=" + formik.values.season + "&saleNo=" + formik.values.saleNo,
                  data
                )
                .then((res) => {
                  if (res.data.statusCode === 202) {
                    CustomToast.success(res.data.message);
                    fileInputRef.current.value = "";
                    setOpenConformaionModal(true);
                    closeLoader();
                  } else if (res.data.statusCode === 423) {
                    // CustomToast.warning(response.data.message);
                    setOpenModalConformationInvalidData(true);
                    setOpenModalConformationInvalidDataTitle({
                      title: res.data.message,
                      responseData: res.data.responseData,
                    });
                    setOpenConformaionModal(false);
                    closeLoader();
                  } else {
                    CustomToast.error(res.data.message);
                    closeLoader();
                  }

                  // closeLoader();
                })
                .catch(() => closeLoader());
              // isValidData = true;
            } else {
              CustomToast.error(res.data.message);
              // isValidData = false;
              closeLoader();
            }
          })
          .catch(() => closeLoader());
      }
      // debugger;
    } else {
      CustomToast.error("Validation is unsuccessful");
    }
  };
  const handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    let count = 0;
    let boolcheckAllColumn;
    // const file = e.target.files[0];

    try {
      const newpropchng = sampleshortage.map((ele) => {
        if (ele.title === "Lot No") {
          return { ...ele, title: "LOTNO" };
        } else if (ele.title === "Package No") {
          return { ...ele, title: "PACKAGENO" };
        } else if (ele.title === "ShortWeight") {
          return { ...ele, title: "SHORTWT" };
        } else if (ele.title === "SampleWeight") {
          return { ...ele, title: "SAMPLEWT" };
        } else if (ele.title === "Re-Inspection Charges") {
          return { ...ele, title: "ReInspectionChgs" };
        } else if (ele.title === "Inspection Charges") {
          return { ...ele, title: "InspectionChgs" };
        } else return ele;
      });

      // if (boolcheckAllColumn) {

      selectedFiles.forEach(async (selectedFile) => {
        boolcheckAllColumn = await checkAllcoulm(selectedFile, newpropchng);
        const fileNameParts = selectedFile.name.split(".");
        const fileSize = selectedFile.size;
        const fileExtension =
          fileNameParts[fileNameParts.length - 1].toLowerCase();

        if (selectedFile.size > 10 * 1024 * 1024) {
          CustomToast.error(`The file size should not exceed 10MB`);
          return;
        } else if (fileExtension !== "xls" && fileExtension !== "xlsx") {
          // CustomToast.error(
          //   `Only Excel files are allowed for ${selectedFile.name}`
          // );
          CustomToast.error(`Only Excel files are allowed.`);
          return;
        } else if (fileSize === 0) {
          CustomToast.error(`File with 0 KB size is not allowed`);
        } else {
          if (boolcheckAllColumn) {
            count = count + 1;
            // Your validation logic for predefined format here
            if (selectedFiles.length === count) {
              processFile(selectedFile);
            }
          }
        }
        // CustomToast.success(`File ${selectedFile.name} uploaded successfully`);
      });

      setFiles(selectedFiles);
      // }
      // handleSubmit();
      // Use vbool as needed
    } catch (error) {
      console.error("Error checking columns:", error);
    }
  };

  const processFile = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming the first sheet in the Excel file contains data
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the worksheet data into a JSON object
      let jsonData = XLSX.utils.sheet_to_json(worksheet);
      //jsonData = jsonData.filter((ele) => ele.hasOwnProperty("LOTNO"));
      // Check for mandatory columns and blank cells
      // jsonData.forEach((row, rowIndex) => {
      //   if (!row["MandatoryColumn1"] || !row["MandatoryColumn2"]) {
      //     CustomToast.error(
      //       `Row ${rowIndex + 2}: Mandatory columns are missing data`
      //     );
      //   }
      // });

      // Process jsonData further or save it as needed
      console.log("JSON Data:", jsonData);
      // let fileData = jsonData.filter(
      //   (ele) =>
      //     ele?.LOTNO !== undefined ||
      //     ele?.PACKAGENO !== undefined ||
      //     ele?.ReInspectionChgs !== undefined ||
      //     ele?.SAMPLEWT !== undefined ||
      //     ele?.SHORTWT !== undefined
      // );
      jsonData =
        jsonData.map(ele => ({
          ...ele, SAMPLEWT: ele.SAMPLEWT === "" ? "" : ele.SAMPLEWT.toFixed(2), SHORTWT: ele.SHORTWT === "" ? "" : ele.SHORTWT.toFixed(2),
          InspectionChgs: ele.InspectionChgs === "" ? "" : ele.InspectionChgs.toFixed(2), ReInspectionChgs: ele.ReInspectionChgs === "" ? "" : ele.ReInspectionChgs.toFixed(2)
        }))
          .filter(
            (ele) =>
              (ele?.LOTNO !== undefined && ele?.LOTNO !== "") ||
              (ele?.PACKAGENO !== undefined && ele?.PACKAGENO !== "") ||
              (ele?.ReInspectionChgs !== undefined && ele?.ReInspectionChgs !== "") ||
              (ele?.SAMPLEWT !== undefined && ele?.SAMPLEWT !== "") ||
              (ele?.SHORTWT !== undefined && ele?.SHORTWT !== "")
          );
      setRows([
        ...rows,
        ...jsonData.filter(
          (ele) =>
            ele?.LOTNO !== undefined ||
            ele?.PACKAGENO !== undefined ||
            ele?.ReInspectionChgs !== undefined ||
            ele?.SAMPLEWT !== undefined ||
            ele?.SHORTWT !== undefined
        ),
      ]);

      // debugger;
    };

    reader.readAsArrayBuffer(file);
  };

  const sampleshortage = [
    // {
    //   name: "select",
    //   title: "Select",
    //   getCellValue: ({ ...row }) => <AWRCheckBox data={row} />,
    // },

    {
      name: "LOTNO",
      title: "Lot No",
    },
    {
      name: "PACKAGENO",
      title: "Package No",
    },
    {
      name: "InspectionChgs",
      title: "Inspection Charges",
    },
    {
      name: "ReInspectionChgs",
      title: "Re-Inspection Charges",
    },
    {
      name: "SAMPLEWT",
      title: "SampleWeight",
    },
    {
      name: "SHORTWT",
      title: "ShortWeight",
    },

    // {
    //   name: "action",
    //   title: "Action",
    //   getCellValue: ({ ...row }) => <ActionArea data={row} />,
    // },
  ];

  const createMenually = () => {
    let data = rows.map((ele) => {
      let rowData = {
        LotNo: ele.LOTNO?.toString(),
        packageNo: ele.packageNo?.toString(),
        createdBy: userId,
        season: ele.season?.toString(),
        saleNo: parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
        auctionCenterId: auctionCenterId,
      };
      return rowData;
    });
    openLoader();
    axiosMain
      .post(`/preauction/${baseUrlEng}/CheckPackageNoByLotNo?season=` + seasonpass + "&saleNo=" + saleNopass, data)
      .then((res) => {
        if (res.data.statusCode === 200) {
          // CustomToast.success(res.data.message);

          let data = rows.map((ele) => {
            let results = {
              LotNo: ele.LOTNO?.toString(),
              packageNo: ele.PACKAGENO?.toString(),
              sampleWeight: parseFloat(ele.SAMPLEWT),
              shortWeight: parseFloat(ele.SHORTWT),
              inspectionCharges: parseFloat(ele.InspectionChgs),
              reInspectionCharges: parseFloat(ele.ReInspectionChgs),
              isActive: true,
              createdBy: userId, //auctioner
              updatedBy: userId, //auctioner
              // season:ele.season?.toString(),
              // saleNo:parseInt(ele.saleNo===""?0:ele.saleNo),
              auctionCenterId: auctionCenterId,
            };

            return results;
          });
          axiosMain
            .post(
              `/preauction/${baseUrlEng}/UploadSampleShortage?role=` + roleCode + "&season=" + formik.values.season + "&saleNo=" + formik.values.saleNo,
              data
            )
            .then((res) => {
              if (res.data.statusCode === 200) {
                getSampledata();
                CustomToast.success(res.data.message);
              } else if (res.data.statusCode === 423) {
                // CustomToast.warning(response.data.message);
                setOpenModalConformationInvalidData(true);
                setOpenModalConformationInvalidDataTitle({
                  title: res.data.message,
                  responseData: res.data.responseData,
                });
              } else {
                CustomToast.error(res.data.message);
              }
              closeLoader();
            })
            .catch(() => closeLoader());
        } else {
          closeLoader();
          CustomToast.error(res.data.massage);
        }
      });

    console.log(rows, "rowsrows");
  };
  // const handleButtonClick = () => {
  //   fileInputRef.current.click();
  // };

  return (
    <div>
      <MenualForm
        rows={rows}
        setRows={setRows}
        handleSubmit={createMenually}
        viewData={viewData}
        isDisable={isDisable}
        seasonpass={seasonpass}
        saleNopass={saleNopass}
        isEdit={isEdit}
        setExpandedTab={setExpandedTab}
        getSampledata={getSampledata}
        dataRow={dataRow}
      />
      {isDisable || isEdit ? (
        ""
      ) : (
        <>
          <div className="row mt-3">
            <div className="col-md-12">
              <p className="Red">
                <b>Instructions:</b>
              </p>
            </div>
            <div className="col-md-12">
              <ul style={{ marginLeft: "2rem !important" }}>
                <li>
                  <p className="Red">
                    ● Any number of excel file can be uploaded.
                  </p>
                </li>
                <li>
                  <p className="Red">
                    ● Maximum file size should not exceed 10 MB.
                  </p>
                </li>
                <li>
                  <p className="Red">
                    ● Acceptable file types: (*.xls and .xlsx)
                  </p>
                </li>
              </ul>
            </div>

            {/* <br /> */}

            {/* <div className="col-md-12">
              <ul style={{ listStyle: "disc", padding: "1%" }}>
                <li>Any number of excel file can be uploaded. </li>
                <li> Maximum file size should not exceed {"<10>"} MB</li>
                <li>Acceptable file types: (*.xls and.xlsx)</li>
              </ul>
            </div> */}
            <form onSubmit={formik.handleSubmit} className="col-md-12">
              <div className="row align-items-end">
                <div className="col-lg-2">
                  <label>Season</label>
                  <InputGroup>
                    <FormControl
                      as="select"
                      name="season"
                      value={formik.values.season}
                      onChange={handleChange}
                    >
                      <option value="">Please Select Season</option>
                      {generateYearOptions()}
                    </FormControl>
                  </InputGroup>
                  {formik.errors.season && formik.touched.season && (
                    <div className="error text-danger">
                      {formik.errors.season}
                    </div>
                  )}
                </div>
                <div className="col-lg-2">
                  <label>Sale No</label>
                  <InputGroup>
                    <FormControl
                      as="select"
                      name="saleNo"
                      value={formik.values.saleNo}
                      onChange={handleChange}
                    >
                      <option value="0">Please Select Sale No</option>
                      {saleNumber?.map((e) => (
                        <option key={e.SaleNoId} value={e.saleNo}>
                          {e.saleNo}
                        </option>
                      ))}
                    </FormControl>
                  </InputGroup>
                  {formik.errors.saleNo && formik.touched.saleNo && (
                    <div className="error text-danger">
                      {formik.errors.saleNo}
                    </div>
                  )}
                </div>
              </div>

              <div className="col-md-12">
                <button
                  className="SubmitBtn"
                  style={{ borderRadius: "6px" }}
                  type="button"
                  onClick={() => {
                    document.getElementById("file-upload").value = "";
                    setRows([]);
                    // setTableData([]);
                    // setInvoiceData([]);
                    // setUploadData([]);
                  }}
                >
                  Clear
                </button>
              </div>
              <div className="col-md-12 mt-3">
                <div className="browse-file FileUpload px-0">
                  <button
                    className="SubmitBtn"
                    type="submit"
                  // onClick={handleButtonClick}
                  >
                    Browse
                  </button>
                  <input
                    type="file"
                    accept=".xls,.xlsx"
                    id="file-upload"
                    multiple
                    onChange={handleFileChange}
                    ref={fileInputRef}
                  />
                  <button type="button" className="SubmitBtn creat-btn" onClick={handleSubmit}>
                    Validate
                  </button>
                </div>
              </div>

            </form>


          </div>
          <div id="invoiceTable" className="mt-4">
            <TableComponent
              columns={sampleshortage}
              rows={rows}
              setRows={setRows}
              dragdrop={true}
              module="pre-auction"
              fixedColumnsOn={false}
              resizeingCol={false}
              selectionCol={true}
              sorting={true}
            />
          </div>
        </>
      )}
      {/* <ToastContainer /> */}
      <Modals
        show={openModalConformationInvalidData}
        size="xl"
        // onHide={() => setShow(false)}
        handleClose={() => setOpenModalConformationInvalidData(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        title={openModalConformationInvalidDataTitle?.title}
      >
        <ul>
          {openModalConformationInvalidDataTitle?.responseData?.length > 0
            ? openModalConformationInvalidDataTitle?.responseData?.map(
              (ele, index) => <li key={index}>● {ele.InvalidRecord}</li>
            )
            : ""}
        </ul>
      </Modals>

      <Modals
        size="l"
        title="Are you sure you want to submit the Sample & Shortage ?"
        show={openConformaionModal}
        handleClose={() => {
          setOpenConformaionModal(false);
        }}
      >
        <div className="BtnGroup" style={{ justifyContent: "end" }}>
          <button
            // className="SubmitBtn"
            className="SubmitBtn"
            onClick={() => {
              openLoader();
              // console.log(rows, "rowrowrow");
              let data = rows.map((ele) => {
                let results = {
                  LotNo: ele.LOTNO?.toString(),
                  packageNo: ele.PACKAGENO?.toString(),
                  sampleWeight: parseFloat(ele.SAMPLEWT),
                  shortWeight: parseFloat(ele.SHORTWT),
                  inspectionCharges: parseFloat(ele.InspectionChgs),
                  reInspectionCharges: parseFloat(ele.ReInspectionChgs),
                  isActive: true,
                  createdBy: userId, //auctioner
                  updatedBy: userId, //auctioner
                  // season: ele.season?.toString(),
                  // saleNo: parseInt(ele.saleNo === "" ? 0 : ele.saleNo),
                  auctionCenterId: auctionCenterId,
                };

                return results;
              });

              axiosMain
                .post(
                  `/preauction/${baseUrlEng}/UploadSampleShortage?role=` +
                  roleCode +
                  "&validateAction=submit&dataFlag=Excel&season=" + formik.values.season + "&saleNo=" + formik.values.saleNo,
                  data
                )
                .then((res) => {
                  if (res.data.statusCode === 200) {
                    getSampledata();
                    CustomToast.success(res.data.message);
                    //setOpenConformaionModal(false);
                    setExpandedTab("panel1");
                    setRows([]);
                    document.getElementById("file-upload").value = "";
                  } else if (res.data.statusCode === 423) {
                    // CustomToast.warning(response.data.message);
                    setOpenModalConformationInvalidData(true);
                    setOpenModalConformationInvalidDataTitle({
                      title: res.data.message,
                      responseData: res.data.responseData,
                    });
                    closeLoader();
                  } else {
                    CustomToast.error(res.data.message);
                    closeLoader();
                  }
                  setOpenConformaionModal(false);
                  // closeLoader();
                });
            }}
          >
            Submit
          </button>

          <button
            className="SubmitBtn"
            // className="SubmitBtn"
            onClick={() => {
              document.getElementById("file-upload").value = "";
              setOpenConformaionModal(false);
              setRows([]);
            }}
          >
            Cancel
          </button>
        </div>
      </Modals>
    </div>
  );
}

export default ExcelUploadComponent;
